module.exports = __webpack_public_path__ + "assets/img/18.0c2feb46.png";